import {LoyaltyUser} from '@winelivery-org/wl-client-sdk-js';
import {useLocale, useTranslations} from 'next-intl';
import NextLink from 'next/link';
import {Button} from '../../../../components/design-system';
import {Link, getPathname} from '../../../../navigation';
import useSession from '../../../../stores/session/useSession';
import UserCorks from './commons/UserCorks';
import useFindLoyaltyUserByIdQuery from './query/useFindLoyaltyUserByIdQuery';

interface Props {
  data?: LoyaltyUser;
}

export default function SectionHeader(props: Props) {
  const {user} = useSession();
  const {data} = useFindLoyaltyUserByIdQuery();
  const t = useTranslations('loyalty');
  const tc = useTranslations('common');
  const locale = useLocale();

  const pathname = getPathname({
    locale: locale as 'de',
    href: '/wallet',
  });
  console.log('pathname!', pathname);
  return (
    <div className="tw-mb-16 tw-bg-greyscale-pink tw-py-8 sm:tw-py-16 tw-px-4">
      <div className="tw-max-w-5xl tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8">
        <h1 className="px-4 tw-text-5xl tw-font-bold tw-text-greyscale-title tw-tracking-tighter sm:tw-text-center tw-m-0 tw-p-0">
          {t('wallet.header.title')}
        </h1>
        <p className="px-4 tw-text-lg tw-text-justify tw-font-medium tw-tracking-tight tw-text-greyscale-body sm:tw-text-center tw-m-0 tw-p-0">
          {t('wallet.header.description')}
        </p>
        {!user ? (
          <Link
            href={{
              pathname: '/auth/signin',
              query: {redirect: pathname},
            }}
          >
            <Button size="lg" type="link" className="tw-w-52">
              {tc('loginRequired.title')}
            </Button>
          </Link>
        ) : props.data ? (
          <div>
            <UserCorks corks={data!.data.loyaltyPointsAvailable} />
            <div className={'tw-mx-auto tw-text-center tw-mt-8'}>
              <NextLink href={`/${locale}${pathname}#movements`}>
                {t('wallet.header.goToMovements')}
              </NextLink>
            </div>
          </div>
        ) : (
          <> </>
        )}
      </div>
    </div>
  );
}
